import Reveal from "../components/Reveal";
import VideoCard from "../components/VideoCard";
import QuoteForm from "../components/QuoteForm";
import ClientMarquee from "../components/ClientMarquee";
import SEO from "../components/SEO";
import { serviceJsonLd } from "../data/seo";
import { CheckCircle2 } from "lucide-react";

const DRONE_SHOWREEL = {
  id: "665944961",
  title: "Yellow Drone Showreel",
  client: "Yellow Drone",
};

const INCLUDES = [
  "CAA-certified, fully insured drone pilots",
  "Pre-flight risk assessments handled by us",
  "4K stills & cinematic 4K aerial footage",
  "Editing & colour grading included",
  "Permission liaison for restricted airspace",
];

export default function Drone() {
  return (
    <main className="pt-28 pb-12" data-testid="drone-page">
      <SEO
        title="Drone Filming Liverpool | Aerial Photography | Yellow"
        description="CAA-licensed drone filming & aerial photography in Liverpool. 4K aerial footage for property, events, construction & marketing. Fully insured pilots, UK wide. Quote in 4 hours."
        path="/drone-filming-aerial-photography-liverpool"
        keywords="drone filming liverpool, drone liverpool, aerial photography liverpool, drone photography liverpool, drone operator liverpool, aerial filming liverpool, drone pilot liverpool, caa drone liverpool, drone hire liverpool"
        jsonLd={serviceJsonLd({
          name: "Drone Filming & Aerial Photography Liverpool",
          description:
            "CAA-certified drone filming and aerial photography services in Liverpool, covering property, events, construction and marketing.",
          path: "/drone-filming-aerial-photography-liverpool",
        })}
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Drone", path: "/drone-filming-aerial-photography-liverpool" },
        ]}
      />
      <section className="yv-container">
        <Reveal>
          <p className="yv-eyebrow">Drone Filming Liverpool · Aerial Photography</p>
          <h1 className="yv-h1 mt-3 max-w-5xl">
            <span style={{ color: "var(--yellow)" }}>Drone filming in Liverpool</span> by CAA-certified pilots, aerial photography and 4K aerial footage UK-wide.
          </h1>
          <p className="text-white/70 max-w-3xl mt-6 text-lg leading-relaxed">
            Looking for <strong className="text-white">aerial photography in Liverpool</strong>? Yellow's fully licensed and insured drone pilots deliver broadcast-quality 4K aerial footage and stills for property, events, construction and brand marketing, across the entire UK.
          </p>
        </Reveal>
      </section>

      <section className="yv-container !mt-12">
        <Reveal>
          <div className="max-w-5xl mx-auto">
            <VideoCard video={DRONE_SHOWREEL} size="lg" testId="drone-showreel-card" />
          </div>
        </Reveal>
      </section>

      <ClientMarquee />

      <section className="yv-container !mt-20 grid lg:grid-cols-2 gap-12 items-start">
        <Reveal>
          <h2 className="yv-h2 text-white mb-4">Our new drone package includes:</h2>
          <ul className="space-y-3 mt-6">
            {INCLUDES.map((i) => (
              <li key={i} className="flex gap-3 text-white/80">
                <CheckCircle2 className="text-[var(--yellow)] flex-shrink-0 mt-0.5" size={20} />
                <span>{i}</span>
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={120}>
          <QuoteForm heading="Get a quote for drone photography / footage" />
        </Reveal>
      </section>
    </main>
  );
}
